module.exports = __webpack_public_path__ + "img/receipt.19c66eaa.svg";